export default __webpack_public_path__ + "static/media/news-bot.a7eeaac8.png";